import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from './supabaseClient';

export default function UpdatePassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Check if we have a valid session
  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) {
        console.log('UpdatePassword: No valid session found, redirecting to sign in');
        navigate('/signin');
      }
    };
    checkSession();
  }, [navigate]);

  const handleUpdatePassword = async () => {
    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }

    if (newPassword.length < 6) {
      setMessage('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      console.log('UpdatePassword: Attempting to update password');
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });

      if (error) {
        console.error('UpdatePassword: Error:', error);
        setMessage(error.message);
      } else {
        console.log('UpdatePassword: Password updated successfully');
        setMessage('Password updated successfully! Redirecting to sign in...');
        // Sign out the user
        await supabase.auth.signOut();
        // Redirect to sign in after 2 seconds
        setTimeout(() => navigate('/signin'), 2000);
      }
    } catch (error) {
      console.error('UpdatePassword: Unexpected error:', error);
      setMessage('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Update Password</h2>
      
      <div className="form-group">
        <label htmlFor="newPassword">New Password</label>
        <input
          id="newPassword"
          type="password"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          placeholder="Enter new password"
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label htmlFor="confirmPassword">Confirm Password</label>
        <input
          id="confirmPassword"
          type="password"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          placeholder="Confirm new password"
          disabled={loading}
        />
      </div>

      <button
        onClick={handleUpdatePassword}
        disabled={loading}
        style={{
          background: 'transparent',
          color: loading ? '#666' : '#fff',
          fontWeight: 600,
          border: `1px solid ${loading ? '#666' : '#fff'}`,
          borderRadius: 6,
          padding: '10px 24px',
          cursor: loading ? 'not-allowed' : 'pointer',
          width: '100%'
        }}
      >
        {loading ? 'Updating...' : 'Update Password'}
      </button>

      {message && (
        <div style={{ 
          marginTop: '15px',
          padding: '10px',
          borderRadius: '6px',
          backgroundColor: message.includes('successfully') ? '#4CAF50' : '#ff4757',
          color: 'white'
        }}>
          {message}
        </div>
      )}

      <div style={{marginTop: 18, textAlign: 'center'}}>
        <Link to="/signin" style={{color: '#fff'}}>Back to Sign In</Link>
      </div>
    </div>
  );
} 